import { render, staticRenderFns } from "./LawDeptlistConfirm.vue?vue&type=template&id=187d7932&"
import script from "./LawDeptlistConfirm.vue?vue&type=script&lang=js&"
export * from "./LawDeptlistConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports